import { gql } from "@apollo/client";

export const CUSTOM_FIELD_VALUES_FRAGMENT = `
  customFieldValues {
    fieldId
    textValue
    numericValue
    dateValue
    optionId
    multiOptionIds
    multiOptionLabels
  }
`;

export const Get_Custom_Fields = gql`
  query GetCustomFields($skip: Int, $take: Int) {
    customFields(skip: $skip, take: $take, order: [{ sortOrder: ASC }]) {
      items {
        id
        displayName
        description
        fieldType
        fieldSubType
        isImportant
        sortOrder
        createdOn
        modifiedOn
        mappedName
        data
        leadCustomOptions {
          id
          value
          customFieldId
          createdOn
          modifiedOn
        }
      }
    }
  }
`;

export const Get_Custom_field_Quota = gql`
  query {
    customFieldQuota {
      items {
        id
        fieldType
        fieldCount
        limit
      }
    }
  }
`;
